import { Request } from '~src/httpClient/serverApi/requests/Request';
import { IGetSiteEncryptionKeyResult } from '~src/settings/security-settings/sections/extract-encryption/models/ExtractEncryptionModels';

export interface IGetSiteEncryptionKeyParams {}


export class GetSiteEncryptionKeyRequest extends Request<IGetSiteEncryptionKeyParams, IGetSiteEncryptionKeyResult> {
  constructor(params: IGetSiteEncryptionKeyParams) {
    super('getSiteEncryptionKey', params);
  }
}